import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
const IconAmountUpper = (props) => {
    const id = useId();
    return (<IconWithGradient viewBox="0 0 24 24" id={id} width={24} height={24} defaultGradientKey="skyBlue" {...props}>
      <Path d="M9.96566 5.05062C9.25393 4.53692 8.25401 4.63628 7.65822 5.3064C7.06279 5.97677 7.08201 6.98091 7.67581 7.62738L7.80303 7.75188L13.1054 12.4656L7.94919 16.1318C7.16975 16.6863 6.98746 17.7679 7.54183 18.5475C8.0964 19.3266 9.17808 19.5091 9.95754 18.9548L15.4683 15.0369L15.6158 14.9246C17.0593 13.7665 17.177 11.5998 15.8676 10.2921L15.7322 10.1649L10.1037 5.16159L9.96566 5.05062Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
export default IconAmountUpper;
